<script setup lang="ts">
import { defineAsyncComponent } from 'vue'
import LoadingHandler from '@/layout/loading/LoadingHandler.vue'
import { productBus } from '@/event/product/productBus'
import { showSelectedModalProductHappy } from '@/happyTheme/event/product/showSelectedModalProductHappy'
import { messageAlertSelectProductHappy } from '@/happyTheme/event/product/messageAlertSelectProductHappy'
import ModalProductHappy from '@/happyTheme/components/product/ModalProductHappy.vue'
import MessageAlertSelectedProductHappy from '@/happyTheme/components/product/alert/MessageAlertSelectedProductHappy.vue'
import ModalBasketHappy from '@/happyTheme/components/layout/modal/modalBasket/ModalBasketHappy.vue'
import { showModalBasketHappy } from '@/happyTheme/event/modalBasket/showModalBasketHappy'
import { messageLogin } from '@/event/account/alert/messageLogin'
import ModalMessageAlertLoginHappy from '@/happyTheme/components/account/login/alert/ModalMessageAlertLoginHappy.vue'
import ModalMessageAlertRegisterHappy from '@/happyTheme/components/account/register/alert/ModalMessageAlertRegisterHappy.vue'
import { messageRegister } from '@/event/account/alert/messageRegister'
import MessageAlertDisconnectHappy from '@/happyTheme/components/account/disconnect/MessageAlertDisconnectHappy.vue'
import { messageAlertDisconnectHappy } from '@/happyTheme/event/messageDisconnect/messageAlertDisconnectHappy'
import AlertMessageDashboardHappy from '@/happyTheme/components/account/alert/AlertMessageDashboardHappy.vue'
import { alertMessageHappy } from '@/happyTheme/event/dashboard/alert/AlertMessageHappy'
import AlertDeleteAddressHappy from '@/happyTheme/components/account/alert/AlertDeleteAddressHappy.vue'
import { alertMessageDeleteAddressHappy } from '@/happyTheme/event/dashboard/address/alertMessageDeleteAddressHappy'
import ModalAddressHappy from '@/happyTheme/components/account/dashboard/address/ModalAddressHappy.vue'
import { showModalAddressHappy } from '@/happyTheme/event/dashboard/address/showModalAddressHappy'
import ModalShowOrderHappy from '@/happyTheme/components/account/dashboard/order/ModalShowOrderHappy.vue'
import { selectedOrder } from '@/event/account/dashboard/history/selectedOrder'
import ModalDeliveryZonesHappy from '@/happyTheme/components/order/option/ModalDeliveryZonesHappy.vue'
import { showDeliveryZones } from '@/event/order/showDeliveryZones'

const HeaderHappy = defineAsyncComponent(
    () => import('@/happyTheme/components/layout/header/HeaderHappy.vue')
)
const FooterHappy = defineAsyncComponent(
    () => import('@/happyTheme/components/layout/FooterHappy.vue')
)
</script>

<template>
    <section class="w-full h-screen flex flex-col justify-between relative">
        <div class="w-full flex flex-col items-center">
            <section class="w-full">
                <HeaderHappy />
                <div class="h-[96px]"></div>
            </section>

            <ModalProductHappy v-if="showSelectedModalProductHappy && productBus" />
            <ModalBasketHappy v-if="showModalBasketHappy" />

            <ModalMessageAlertLoginHappy v-if="messageLogin.class" />
            <ModalMessageAlertRegisterHappy v-if="messageRegister.class" />
            <MessageAlertDisconnectHappy v-if="messageAlertDisconnectHappy.class" />

            <ModalShowOrderHappy v-if="selectedOrder !== undefined" />

            <ModalAddressHappy v-if="showModalAddressHappy" />
            <AlertDeleteAddressHappy v-if="alertMessageDeleteAddressHappy.class" />

            <AlertMessageDashboardHappy v-if="alertMessageHappy.class" />

            <MessageAlertSelectedProductHappy
                :option="messageAlertSelectProductHappy.option"
                :type="messageAlertSelectProductHappy.type"
                :message="messageAlertSelectProductHappy.message"
            />

            <ModalDeliveryZonesHappy v-if="showDeliveryZones" />

            <LoadingHandler />
        </div>
        <FooterHappy />
    </section>
</template>

<style scoped></style>
